
import React, { Suspense } from 'react';
import { Loader2 } from 'lucide-react';

// 懒加载专用引擎
const SandboxEngine = React.lazy(() => import('./canvas/SandboxEngine'));
const SvgEngine = React.lazy(() => import('./canvas/SvgEngine'));
const PeriodicTableEngine = React.lazy(() => import('./canvas/PeriodicTableEngine'));
const NewtonDrive = React.lazy(() => import('./canvas/NewtonDrive'));
const LogicGraph = React.lazy(() => import('./canvas/LogicGraph'));
const BioScope = React.lazy(() => import('./canvas/BioScope'));

interface CanvasWidgetProps {
  data: {
    engine: 'svg' | 'periodic_table' | 'sandbox' | 'physics' | 'newton' | 'logic_graph' | 'bio_scope';
    payload: any;
  };
  isDark: boolean;
  onPlayAudio?: (text: string) => void;
}

export const CanvasWidget: React.FC<CanvasWidgetProps> = ({ data, isDark, onPlayAudio }) => {
  const { engine, payload } = data;

  const renderEngine = () => {
    switch (engine) {
      case 'bio_scope':
        return <BioScope payload={payload} isDark={isDark} onPlayAudio={onPlayAudio} />;
      case 'logic_graph':
        return <LogicGraph payload={payload} isDark={isDark} />;
      case 'newton':
      case 'physics':
        return <NewtonDrive payload={payload} isDark={isDark} />;
      case 'sandbox':
        return <SandboxEngine payload={payload} isDark={isDark} />;
      case 'periodic_table':
        return <PeriodicTableEngine payload={payload} isDark={isDark} onPlayAudio={onPlayAudio} />;
      case 'svg':
        return <SvgEngine payload={payload} isDark={isDark} onPlayAudio={onPlayAudio} />;
      default:
        return (
          <div className="p-12 text-center opacity-40 border-2 border-dashed rounded-3xl">
             Unknown Engine: {engine}
          </div>
        );
    }
  };

  return (
    <div className="w-full relative group">
      <Suspense fallback={
        <div className="h-64 flex flex-col items-center justify-center animate-pulse">
          <Loader2 className="animate-spin text-indigo-500 mb-2" />
          <span className="text-[10px] font-black uppercase tracking-widest opacity-40">Initializing Life Engine...</span>
        </div>
      }>
        {renderEngine()}
      </Suspense>
    </div>
  );
};
